import { CERTIFICATES_DIV_ID, IPARQUE_MODULES, IPARQUE_ONSTREET } from "configs/links";
import { Language } from "interfaces/locale";

export type RouteKeys =
  | "home"
  | "about"
  | "callMeBack"
  | "contactRequest"
  | "certificates"
  | "modules";

export type ExternalRouteKeys = "onStreet" | "street" | "enforcer";

export const ROUTES: Record<Language, Record<RouteKeys, string>> = {
  pt: {
    home: "",
    about: "/sobre",
    callMeBack: "/ligue-me",
    contactRequest: "/pedido-contacto",
    certificates: `/sobre/#${CERTIFICATES_DIV_ID}`,
    modules: `${IPARQUE_MODULES}`,
  },
  en: {
    home: "",
    about: "/about",
    callMeBack: "/call-me-back",
    contactRequest: "/contact-request",
    certificates: `/about/#${CERTIFICATES_DIV_ID}`,
    modules: `${IPARQUE_MODULES}`,
  },
  es: {
    home: "",
    about: "/sobre-nosotros",
    callMeBack: "/llamame",
    contactRequest: "/solicitud-de-contacto",
    certificates: `/sobre-nosotros/#${CERTIFICATES_DIV_ID}`,
    modules: `${IPARQUE_MODULES}`,
  },
} as const;

export const EXTERNAL_ROUTES = {
  pt: {
    onStreet: `${IPARQUE_ONSTREET}`,
    enforcer: `${IPARQUE_ONSTREET}enforcer/`,
    street: `${IPARQUE_ONSTREET}street/`,
  },
  en: {
    onStreet: `${IPARQUE_ONSTREET}en/`,
    enforcer: `${IPARQUE_ONSTREET}en/enforcer/`,
    street: `${IPARQUE_ONSTREET}en/street/`,
  },
  es: {
    onStreet: `${IPARQUE_ONSTREET}es/`,
    enforcer: `${IPARQUE_ONSTREET}es/enforcer/`,
    street: `${IPARQUE_ONSTREET}es/street/`,
  },
};
